import React from "react";
import { compose } from "recompose";
import EnhanceCategory from "./EnhanceCategory";
import CategoryQuery from "./CategoryQuery.gql";
import Loadable from "theme/components/helpers/Loadable";
import LoadingRoute from "theme/modules/Router/LoadingRoute";
import withTrackPage from "theme/modules/Analytics/withTrackPage";
import withFilterableCategoryTracking from "theme/modules/Category/withFilterableCategoryTracking";
import useCanonicalCategoryUrl from "theme/pages/Category/useCanonicalCategoryUrl";
import LayerPage from "theme/modules/Layer/LayerPage";
import CategorySeo from "theme/modules/Category/CategorySeo";
import Breadcrumb from "theme/components/organisms/Breadcrumb";
import LayerHeader from "theme/modules/Layer/LayerHeader";
import LayerProducts from "theme/modules/Layer/LayerProducts";
import CategoryNavigation, {
  hasCategoryNavigation,
} from "theme/modules/Category/CategoryNavigation";
import EmptyCategory from "theme/modules/Category/EmptyCategory";
import Stack from "theme/components/atoms/Layout/Stack";
import { IMAGE_SIZES } from "./CategoryConstants";
import StorefrontContent from "theme/modules/StorefrontContent/StorefrontContent";

const Category = ({ loading, category, hasFilters, location }) => {
  const breadcrumb = category.breadcrumb.map(({ name, path }) => ({
    name,
    path,
  }));

  const layer = category.layer;
  const canonicalUrl = useCanonicalCategoryUrl(category, location);

  return (
    <StorefrontContent type="Category" id={category.id} scope="page">
      <CategorySeo category={category} canonicalUrl={canonicalUrl} />
      <Breadcrumb paths={breadcrumb} />
      <div className="page-content">
        <LayerPage
          key={category.id}
          loading={loading}
          layer={category.layer}
          header={
            <Stack size="2">
              <LayerHeader
                loading={loading}
                title={category.name}
                layer={category.layer}
              />
              {hasCategoryNavigation(category) ? (
                <CategoryNavigation category={category} />
              ) : null}
            </Stack>
          }
        >
          <LayerProducts
            loading={loading}
            layer={layer}
            hasFilters={hasFilters}
            EmptyComponent={EmptyCategory}
            breadcrumb={breadcrumb}
            imageSizes={IMAGE_SIZES}
            prioritizeTop={6}
          />
        </LayerPage>
      </div>
    </StorefrontContent>
  );
};

export default compose(
  EnhanceCategory({ CategoryQuery }),
  withTrackPage("Category"),
  Loadable((props) => !!props.category, LoadingRoute),
  withFilterableCategoryTracking()
)(Category);
